import { Indicator } from './Indicator'
import { Wrapper } from './Wrapper'

export { StepPosition, type StepProps, StepState, type WrapperProps } from './MultiStepProcessIndicator.types'

export const Steps = {
  Wrapper,
  Indicator,
}
